export default __webpack_public_path__ + "static/media/pc06-4-1.63e42c5e.png";